// src/redux/slices/forgotPasswordSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL || 'http://localhost:5000';
// Async thunk to send the forgot password request
export const sendForgotPasswordRequest = createAsyncThunk(
  'forgotPassword/send',
  async ({ email }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${baseUrl}/users/normal/forgot-password`, {
        email,
      });
      return response.data.message;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Something went wrong'
      );
    }
  }
);

const forgotPasswordSlice = createSlice({
  name: 'forgotPassword',
  initialState: {
    loading: false,
    message: '',
    error: '',
  },
  reducers: {
    // Reset state when navigating away or retrying
    clearForgotState: (state) => {
      state.loading = false;
      state.message = '';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendForgotPasswordRequest.pending, (state) => {
        state.loading = true;
        state.message = '';
        state.error = '';
      })
      .addCase(sendForgotPasswordRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload;
        state.error = '';
      })
      .addCase(sendForgotPasswordRequest.rejected, (state, action) => {
        state.loading = false;
        state.message = '';
        state.error = action.payload;
      });
  },
});

export const { clearForgotState } = forgotPasswordSlice.actions;
export default forgotPasswordSlice.reducer;
